export function prettyStringifyJSON(obj, indent = 2) {
  const space = ' '.repeat(indent)

  function isCompactArray(arr) {
    if (!Array.isArray(arr)) return false
    // Empty arrays or arrays of primitives should be compact
    if (arr.length === 0) return true
    return arr.every(
      item => typeof item === 'number' || typeof item === 'boolean' || typeof item === 'string' || item === null
    )
  }

  function stringify(obj, depth = 0) {
    if (obj === null) return 'null'
    if (typeof obj !== 'object') return JSON.stringify(obj)

    const currentIndent = space.repeat(depth)
    const nextIndent = space.repeat(depth + 1)

    if (Array.isArray(obj)) {
      if (isCompactArray(obj)) {
        // Compact format for empty or primitive arrays
        return '[' + obj.map(v => JSON.stringify(v)).join(', ') + ']'
      }
      // Regular format for complex arrays
      const items = obj.map(item => nextIndent + stringify(item, depth + 1))
      return '[\n' + items.join(',\n') + '\n' + currentIndent + ']'
    }

    // Object handling
    const keys = Object.keys(obj)
    if (keys.length === 0) return '{}'

    const items = keys.map(key => nextIndent + JSON.stringify(key) + ': ' + stringify(obj[key], depth + 1))
    return '{\n' + items.join(',\n') + '\n' + currentIndent + '}'
  }

  return stringify(obj)
}

// // Usage:
// const result = compactStringify(data, 2);
// console.log(result);
